import { render, staticRenderFns } from "./ContractorContacts.vue?vue&type=template&id=95a70088&scoped=true"
import script from "./ContractorContacts.vue?vue&type=script&lang=js"
export * from "./ContractorContacts.vue?vue&type=script&lang=js"
import style0 from "./ContractorContacts.vue?vue&type=style&index=0&id=95a70088&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95a70088",
  null
  
)

export default component.exports